import React from 'react';
import './SNSButtons.sass'
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

function SNSButtons({spacing='2rem'}) {
    return (
        <div className="sns_buttons">
            <a href="https://github.com/eureyuri" target="_blank" rel="noreferrer nofollow">
                <GitHubIcon className="icon__github" style={spacing ? {marginRight: spacing} : {margin: '0 0.5rem'}} />
            </a>
            <a href="https://www.linkedin.com/in/eurey-noguchi/" target="_blank" rel="noreferrer nofollow">
                <LinkedInIcon className="icon__linkedin" style={spacing ? {marginRight: spacing} : {margin: '0 0.5rem'}} />
            </a>
            <a href="https://www.youtube.com/channel/UCOScmlJ9J2xpLwuOYQu4n9Q"
               target="_blank"
               rel="noreferrer nofollow">
                <YouTubeIcon className="icon__youtube" style={spacing ? {marginRight: spacing} : {margin: '0 0.5rem'}} />
            </a>
        </div>
    );
}

export default SNSButtons;